import { Typography, TypographyProps } from "@outschool/backpack";
import React from "react";

type PageSectionTitleProps = {
  title: string;
} & TypographyProps;

const PageSectionTitle = ({
  title,
  ...typegraphyProps
}: PageSectionTitleProps) => {
  const { sx: customSx } = typegraphyProps;
  return (
    <Typography
      emphasized
      variant="h4"
      sx={customSx ? customSx : { paddingBottom: "2rem" }}
      {...typegraphyProps}
    >
      {title}
    </Typography>
  );
};

export default PageSectionTitle;
